module.exports = __webpack_public_path__ + "img/register.bfd3e809.png";